export const DEFAULT_BENEFIT_YEAR_START_MONTH = 9; // October, zero-indexed

export function getBenefitYearStart(
  now = new Date(),
  startMonth = DEFAULT_BENEFIT_YEAR_START_MONTH
): Date {
  const startYear = now.getMonth() >= startMonth ? now.getFullYear() : now.getFullYear() - 1;
  return new Date(startYear, startMonth, 1);
}

export function getBenefitYearEnd(
  now = new Date(),
  startMonth = DEFAULT_BENEFIT_YEAR_START_MONTH
): Date {
  const start = getBenefitYearStart(now, startMonth);
  return new Date(start.getFullYear() + 1, start.getMonth(), 1);
}

export function getBenefitYearMonthsElapsed(
  now = new Date(),
  startMonth = DEFAULT_BENEFIT_YEAR_START_MONTH
): number {
  const start = getBenefitYearStart(now, startMonth);
  return (now.getFullYear() - start.getFullYear()) * 12 + now.getMonth() - start.getMonth() + 1;
}

export function isInCurrentBenefitYear(
  date: Date,
  now = new Date(),
  startMonth = DEFAULT_BENEFIT_YEAR_START_MONTH
): boolean {
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  const start = getBenefitYearStart(now, startMonth);
  const end = getBenefitYearEnd(now, startMonth);
  return date >= start && date < end;
}

export function formatBenefitYearRange(
  now = new Date(),
  startMonth = DEFAULT_BENEFIT_YEAR_START_MONTH
): string {
  const start = getBenefitYearStart(now, startMonth);
  const end = getBenefitYearEnd(now, startMonth);
  const startMonthLabel = String(start.getMonth() + 1).padStart(2, '0');
  const endMonthLabel = String(end.getMonth() + 1).padStart(2, '0');

  return `${startMonthLabel}/01/${String(start.getFullYear()).slice(2)}-${endMonthLabel}/01/${String(
    end.getFullYear()
  ).slice(2)}`;
}
